import { graphql } from 'react-relay';
export const UserProfileClientForConfluenceQuery = graphql`
	query UserProfileClientForConfluenceQuery($userId: ID) {
		user: confluence_atlassianUser(current: false, id: $userId) {
			id
			confluence {
				permissionType
			}
		}
		entitlements {
			externalCollaborator {
				isEntitled
			}
		}
	}
`;
